'use client';

import React, { forwardRef } from 'react';
import { motion, type MotionProps } from 'framer-motion';
import { cn } from '@/lib/utils';
import ResponsiveWrapper, {
  type ResponsiveProperties,
} from './responsive-wrapper.tsx';

/*
 * ZStack
 */
interface ZStackProperties extends MotionProps, ResponsiveProperties {
  id?: string;
  className?: string;
}

const ZStack = forwardRef<HTMLDivElement, ZStackProperties>(
  ({ id, className = '', sm, md, lg, children, ...props }, ref) => {
    return (
      <ResponsiveWrapper sm={sm} md={md} lg={lg}>
        <motion.div
          id={`z-stack${id ? `-${id}` : ''}`}
          ref={ref}
          className={cn('relative w-full h-full', className)}
          {...props}
        >
          {children}
        </motion.div>
      </ResponsiveWrapper>
    );
  },
);

ZStack.displayName = 'ZStack';

/*
 * ZStackChild
 */
interface ZStackChildProperties extends MotionProps, ResponsiveProperties {
  id?: string;
  zIndex?: number;
  className?: string;
}

const ZStackChild = forwardRef<HTMLDivElement, ZStackChildProperties>(
  ({ id, zIndex = 0, className = '', sm, md, lg, children, ...props }, ref) => {
    return (
      <ResponsiveWrapper sm={sm} md={md} lg={lg}>
        <motion.div
          id={`z-stack-child${id ? `-${id}` : ''}`}
          ref={ref}
          className={cn('absolute inset-0', className)}
          style={{ zIndex }}
          {...props}
        >
          {children}
        </motion.div>
      </ResponsiveWrapper>
    );
  },
);

ZStackChild.displayName = 'ZStackChild';

export { ZStack, ZStackChild };
